import { FC } from 'react';

import { TbArrowsSort } from 'react-icons/tb';

import ConverterField from './ConverterField';

import { useConverter } from './useConverter';

import styles from '../../../../calculator.module.scss';

interface IConverterDisplayProps {
  value: string;
  error: string | null;
  sizeClass: string;
  isReadOnly?: boolean;
}

const ConverterDisplay: FC<IConverterDisplayProps> = ({ value, error, sizeClass, isReadOnly = false }) => {
  const {
    openTop,
    setOpenTop,
    openBottom,
    setOpenBottom,
    activeTab,
    setActiveTab,
    selectedTopUnit,
    setSelectedTopUnit,
    selectedBottomUnit,
    setSelectedBottomUnit,
    fieldsSwapped,
    setFieldsSwapped,
    topAnchorRef,
    bottomAnchorRef,
    containerRef,
    converterTabs,
    currentData,
    convertedValue,
    topTabsScroll,
    bottomTabsScroll,
  } = useConverter(value, isReadOnly);

  return (
    <div className={styles.converterContainer} ref={containerRef}>
      <div className={styles.converterInputs}>
        <ConverterField
          type="top"
          value={value}
          convertedValue={convertedValue}
          error={error}
          sizeClass={sizeClass}
          fieldsSwapped={fieldsSwapped}
          selectedUnit={selectedTopUnit}
          anchorRef={topAnchorRef}
          isOpen={openTop}
          onToggle={isReadOnly ? undefined : () => setOpenTop(!openTop)}
          onClose={() => setOpenTop(false)}
          onUnitSelect={setSelectedTopUnit}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          converterTabs={converterTabs}
          currentData={currentData}
          tabsScroll={topTabsScroll}
          isReadOnly={isReadOnly}
        />
        <div className={styles.converterSeparator} onClick={(e) => e.stopPropagation()}>
          <TbArrowsSort
            size={26}
            className={isReadOnly ? styles.fieldIconReadOnly : ''}
            onClick={
              isReadOnly
                ? undefined
                : (e) => {
                    e.stopPropagation();
                    setFieldsSwapped(!fieldsSwapped);
                  }
            }
          />
        </div>
        <ConverterField
          type="bottom"
          value={value}
          convertedValue={convertedValue}
          error={null}
          sizeClass={sizeClass}
          fieldsSwapped={fieldsSwapped}
          selectedUnit={selectedBottomUnit}
          anchorRef={bottomAnchorRef}
          isOpen={openBottom}
          onToggle={isReadOnly ? undefined : () => setOpenBottom(!openBottom)}
          onClose={() => setOpenBottom(false)}
          onUnitSelect={setSelectedBottomUnit}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          converterTabs={converterTabs}
          currentData={currentData}
          tabsScroll={bottomTabsScroll}
          isReadOnly={isReadOnly}
        />
      </div>
    </div>
  );
};

export default ConverterDisplay;
